import React, { useEffect } from "react";
import { XOPublicQuietLoading } from "./XOPublicQuietLoading";

type Props = {
  url: string;
};

/** Same-origin router cannot navigate to arbitrary URLs; use a full navigation for external redirect policy. */
export function BrandedDomainExternalRedirect({ url }: Props): React.ReactElement {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);
  return <XOPublicQuietLoading label="Continuing…" />;
}
